module.exports = __webpack_public_path__ + "static/performance_management-656530c0fca18c5a60262cb302f1bfcc.png";